import { createStore, combineReducers } from "redux";

import { composeWithDevTools } from 'redux-devtools-extension';

import flowReducer, { FlowState } from "./reducers/FlowReducer";


const rootReducer = combineReducers({
  flow: flowReducer,
});

//export type RootState = ReturnType<typeof rootReducer>

export interface RootState { 
  flow: FlowState,
}

//const store: Store<RootState> = createStore(
//  rootReducer as any,
//  // initialState,
//  (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__()
//);


const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });
const store = createStore(rootReducer, composeEnhancers(
  //applyMiddleware(invariant(), thunk)
));

export default store;
